/**
 * MemberVaccinationContext.jsx
 * Context wrapper for the Member Vaccination scenario.
 *
 * This wrapper configures MemberVaccination for the full member vaccination
 * workflow where both Current and Previous tabs are available.
 *
 * ARCHITECTURE NOTE:
 * MemberVaccination is the data-fetching coordinator: it owns all API calls
 * and renders VaccinationContainer (the focused vaccination widget) as a child.
 * Context wrappers exist only to set scenario-specific configuration (allowedTabs)
 * without callers needing to know the internal tab constants.
 */

import React from 'react';
import MemberVaccination from '../../memberVaccination/MemberVaccination';

/**
 * Member Vaccination Context Wrapper
 *
 * @param {Object}   props.beneficiaryData  - Beneficiary row from the session list
 * @param {string}   [props.beneficiaryType]- 'PW' | 'CHILD'. Auto-detected if omitted.
 * @param {Function} props.onContinue       - Called after successful standalone submission
 * @param {Function} props.toggleDrawer     - Closes the parent drawer
 * @param {Function} props.onFormComplete   - Stepper mode: receives form data for review
 * @param {boolean}  props.isStepperMode    - Skip API call and hand off to review step
 */
const MemberVaccinationContext = (props) => {
  return (
    <MemberVaccination
      {...props}
      // Full workflow: both Current and Previous vaccination tabs are enabled
      allowedTabs={['current', 'previous']}
    />
  );
};

export default MemberVaccinationContext;
